<template>
  <div :class="['day', 'my-4', 'w-100', 'd-flex', { holiday: isHoliday }]">
    <div class="d-flex flex-column w-100 m-0">
      <div
        class="mb-3"
        :class="{
          'day-number': !isOutOfTheMonth,
          'out-of-the-month': isOutOfTheMonth,
        }"
      ></div>
      <div v-for="(item, key) in eventsOfTheDay" :key="key" class="mb-2">
        <calendar-event
          :background-color="secondaryColor(item.color)"
          :border-color="item.color"
        >
          <div class="row py-3 pointer" @click="$emit('click', item)">
            <div class="col-12">
              <div v-html="studentName(item)" />
            </div>
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-12 time-mobile">
                  <i
                    class="fas fa-clock mr-2"
                    :style="`color: ${item.color}`"
                  ></i>
                  {{ item.from | hour }} - {{ item.to | hour }}
                </div>
                <div class="col-12 mt-2 caat">
                  <i
                    class="fas fa-map-marker-alt mr-2"
                    :style="`color: ${item.color}`"
                  ></i>
                  {{ item.caatName | empty }}
                </div>
                <div
                  class="line"
                  :style="`border-top: ${border(item.color)}`"
                ></div>
                <div class="col-12 p-0 text-center pr-3 mt-2">
                  <span
                    class="badge badge-pill text-dark bg-white px-3 py-2 status-mobile'"
                  >
                    <custom-balloon
                      :background-color="item.statusColor"
                      :text="item.statusName"
                      dot
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </calendar-event>
      </div>
    </div>
  </div>
</template>
<script>
import CalendarEvent from './CalendarEvent.vue';
import CustomBalloon from 'custom-balloon';

export default {
  name: 'CalendarDay',
  components: {
    CalendarEvent,
    CustomBalloon,
  },
  props: {
    day: {
      type: Date,
      default: null,
    },
    currentDate: {
      type: Date,
      default: () => new Date(),
    },
    showDay: {
      type: Boolean,
      default: true,
    },
    events: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dayNumber() {
      return this.day.getDate();
    },
    isHoliday() {
      var dayOfWeek = this.day.getDay();
      return dayOfWeek === 6 || dayOfWeek === 0;
    },
    border() {
      return (borderColor) => `1px solid ${borderColor}`;
    },
    isOutOfTheMonth() {
      return this.day.getMonth() !== this.currentDate.getMonth();
    },
    eventsOfTheDay() {
      return this.events.filter((event) => {
        return (
          new Date(event.from).getDate() === this.day.getDate() &&
          new Date(event.from).getMonth() === this.day.getMonth() &&
          new Date(event.from).getFullYear() === this.day.getFullYear()
        );
      });
    },
    studentName() {
      return (event) => {
        if (
          (event.isAppointment && (!event.studentSie || !event.studentName)) ||
          (!event.isAppointment && !event.activityTypeName)
        ) {
          return '-';
        }

        const appointment = `<span class="font-16 font-weight-bold">${event.studentName}</span> <br/> <span>${event.studentSie}</span>`;
        const activity = `<span class="font-16 font-weight-bold">${event.activityTypeName}</span> <br/> <span>${event.activityName}</span>`;
        return event.isAppointment ? appointment : activity;
      };
    },
    secondaryColor() {
      return (color) => {
        if (!color) {
          return;
        }
        let c = color.substring(1).split('');
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return (
          'rgba(' +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
          ', 0.15)'
        );
      };
    },
  },
};
</script>
<style scoped lang="scss">
.day {
  display: flex;
  flex-direction: row;
  width: 100% !important;
  height: 100%;
  background-color: #f4f6f3;
  border-radius: 4px;
  padding: 16px;
  justify-content: flex-end;
  min-height: 150px;
}

.day-number {
  color: #000000 !important;
  font-size: 16px;
  font-weight: 700;
  align-self: flex-end;
}

.out-of-the-month {
  color: #9e9e9e !important;
  font-size: 16px;
  font-weight: 700;
  align-self: flex-end;
}
.pointer {
  cursor: pointer;
}

.line {
  width: 100%;
  margin: 10px 20px;
}

.caat,
.time {
  font-size: 14px;
}

.time-mobile {
  font-size: 17px;
}

.status-mobile {
  font-size: 18px;
  margin-bottom: 10px;
}

.holiday {
  background-color: #e2e2e2;
}
</style>
